module.exports = __webpack_public_path__ + "img/powered_by_allsan.26d0235a.png";